import React from 'react';

/* packages */
import { ModuleTitle } from '../../util-atomic-design';
/* packages */

const Index = props => {
  return <ModuleTitle>
    Edit a Quote
  </ModuleTitle>
}

export default Index;
